import { ClientEvents } from 'common/events/ClientEvents';
import {
  CuisineSearchResultFieldsFragment,
  DishSearchResultFragment,
  ShefSearchResultFragment,
} from 'src/gqlReactTypings.generated.d';
import { ITracker } from 'src/tracking/types';

export const trackDishResultClick = (tracker: ITracker, result: DishSearchResultFragment, userQuery: string) => {
  tracker.track(ClientEvents.FOOD_SEARCH_RESULT_CLICK, {
    foodItemId: result.id,
    foodName: result.name ?? null,
    search: userQuery,
  });
};

export const trackShefResultClick = (tracker: ITracker, result: ShefSearchResultFragment, userQuery: string) => {
  tracker.track(ClientEvents.SHEF_SEARCH_RESULT_CLICK, {
    shefId: result.id,
    search: userQuery,
  });
};

export const trackCuisineResultClick = (
  tracker: ITracker,
  result: CuisineSearchResultFieldsFragment,
  userQuery: string
) => {
  tracker.track(ClientEvents.CUISINE_SEARCH_RESULT_CLICK, {
    cuisineCategoryId: result.category.id,
    search: userQuery,
  });
};

export const trackGiftCardResultClick = (tracker: ITracker, userQuery: string) => {
  tracker.track(ClientEvents.GIFT_CARD_SEARCH_RESULT_CLICK, {
    search: userQuery,
  });
};
